module.exports = __webpack_public_path__ + "img/aqfh-img-22.c59efda8.png";